import React from "react";
import { inject, observer } from "mobx-react";
import LayoutChooser from "component/atoms/layoutChooser";

@inject("gridLayoutStore")
@observer
class LayoutChooserContainer extends React.Component {
  handleCellClick = (rowIndex, columnIndex) => {
    const { onCellClick } = this.props;

    if (!!onCellClick === true) {
      onCellClick(rowIndex, columnIndex);
    }
  };

  render() {
    return <LayoutChooser onCellClick={this.handleCellClick} />;
  }
}

export default LayoutChooserContainer;
